import React, { Component } from 'react'
import Modal from '../Modal'
import { Input, Button } from '../Form'
import { incompatibilityAnalysisActions } from '../../actions'
import { pxToRem, color } from '../../utils'
import styled from 'styled-components'
import { connect } from 'react-redux'

const ModalLayout = styled.div`
  display: flex;
  flex-direction: column;
  font-size: ${pxToRem(13)};
  justify-content: center;

  form {
    justify-content: center;
    width: 100%;
  }
`
const WrapperInput = styled.div`
  padding: ${pxToRem(30)};
`

const Footer = styled.div`
  padding: ${pxToRem(13)} ${pxToRem(16)};
  border-top: 1px solid #d8d8d8;

  display: flex;
  justify-content: flex-end;
`

const CancelButton = styled(Button)`
  background: ${color.danger};
  color: #fff;
  border-color: ${color.danger};

  &:hover,
  &:focus {
    box-shadow: 0 0 ${pxToRem('15px')} 0 ${color.danger};
    outline: none;
  }
  &:active {
    box-shadow: inset 0 0 ${pxToRem('5px')} 0 ${color.danger};
    border-color: ${color.danger};
  }
`

const ConfirmButton = styled(Button)`
  margin-left: ${pxToRem('15px')};
`

const CabinetName = styled(Input)`
  text-transform: uppercase;
`

const initialState = {
  cabinet: {
    name: ''
  },
  errorText: ''
}

class CabinetModal extends Component {
  constructor(props) {
    super(props)
    this.state = initialState
  }

  changeCabinet(cabinet) {
    if (cabinet) {
      this.setState({ cabinet })
    } else {
      this.setState(initialState)
    }
  }

  changeCabinetName(name) {
    this.setState(state => ({
      cabinet: {
        ...state.cabinet,
        name
      }
    }))
  }

  componentDidUpdate(prevProps) {
    const { open: prevOpen } = prevProps
    const { open: nextOpen, cabinet } = this.props

    if (prevOpen !== nextOpen && nextOpen) {
      this.changeCabinet(cabinet)
    }
  }

  scrollToEnd() {
    const element = document.getElementById('CabinetsContainer')
    if (element && element.scroll) {
      element.scroll(element.scrollWidth, 0)
    }
  }

  handleError(status) {
    if (status === 400) {
      return 'Nome do armário não pode ficar em branco.'
    } else if (status === 409) {
      return 'Nome já está em uso.'
    }
  }

  onSubmit = () => {
    const { cabinet = {} } = this.state
    const { closeMethod, showError, areaId, addCabinet, updateCabinet } = this.props

    if (cabinet.id) {
      updateCabinet({ areaId, id: cabinet.id, name: cabinet.name })
        .then(() => {
          closeMethod()
        })
        .catch(err => {
          showError('Falha ao atualizar armário', this.handleError(err.response.status))
        })
    } else {
      addCabinet({ areaId, name: cabinet.name })
        .then(() => {
          closeMethod()
          this.scrollToEnd()
        })
        .catch(err => {
          showError('Falha ao adicionar armário', this.handleError(err.response.status))
        })
    }
  }

  isDisabled() {
    const { cabinet } = this.state

    if (cabinet.name === '') {
      return true
    } else {
      return false
    }
  }

  render() {
    const {
      open,
      closeMethod,
      error,
      loadingCabinet,
      cancelText = 'Cancelar',
      confirmText = 'Confirmar'
    } = this.props

    const { cabinet = {}, errorText } = this.state
    return (
      <Modal
        title={`${cabinet.id ? 'Editar' : 'Adicionar'} armário`}
        safeContent={false}
        loading={false}
        open={open}
        size={'small'}
        error={error}
        errorText={errorText}
        closeMethod={closeMethod}
      >
        <ModalLayout>
          <form
            onSubmit={e => {
              e.preventDefault()
              this.onSubmit()
            }}
            disabled={loadingCabinet}
          >
            <WrapperInput>
              <CabinetName
                label={'NOME DO ARMÁRIO'}
                value={cabinet.name || ''}
                onChange={e => this.changeCabinetName(e.target.value)}
                autoFocus={true}
                maxLength={40}
              />
            </WrapperInput>
            <Footer>
              <CancelButton
                onClick={closeMethod}
                type={'button'}
                >{cancelText}</CancelButton>
              <ConfirmButton
                disabled={loadingCabinet || this.isDisabled()}
                type={'submit'}
              >
                {confirmText}
              </ConfirmButton>
            </Footer>
          </form>
        </ModalLayout>
      </Modal>
    )
  }
}
const mapStateToProps = state => ({
  loadingCabinets: state.incompatibilityAnalysis.loading.cabinets,
  loadingCabinet: state.incompatibilityAnalysis.loading.cabinet,
  areaId: state.auth.areaId
})

const mapDispatchToProps = dispatch => {
  return {
    addCabinet: ({ areaId, name }) => {
      return dispatch(incompatibilityAnalysisActions.addCabinet({ areaId, name }))
    },
    updateCabinet: ({ areaId, id, name }) => {
      return dispatch(incompatibilityAnalysisActions.updateCabinet({ areaId, id, name }))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CabinetModal)



// WEBPACK FOOTER //
// ./src/components/Cabinet/CabinetModal.js